export type AdsgramPlacement = 'default'

interface Config {
  isDev?: boolean
  isProd?: boolean
  showDebugger: boolean
  showHitboxes: boolean
  apiHost: string
  botLink: string
  CDN: string
  tonConnectManifestUrl: string
  tonConnectWalletsListSource: string
  accessToken?: string
  adsgramBlockIds: Record<AdsgramPlacement, string>
}

const localdevConfig: Config = {
  isDev: true,
  // Address of the BackStick dev container
  apiHost: import.meta.env.VITE_API_URL,
  showDebugger: true,
  showHitboxes: true,
  botLink: 'https://t.me/OneTimeDogBot',
  CDN: 'https://stickerbot.fra1.cdn.digitaloceanspaces.com',
  tonConnectManifestUrl:
    'https://cdn.joincommunity.xyz/glance-tonconnect-manifest.json',
  tonConnectWalletsListSource:
    'https://raw.githubusercontent.com/ton-connect/wallets-list/main/wallets-v2.json',
  accessToken: import.meta.env.VITE_ACCESS_TOKEN,
  adsgramBlockIds: {
    default: '23836',
  },
}

const devConfig: Config = {
  isDev: true,
  apiHost: import.meta.env.VITE_API_URL,
  showDebugger: true,
  showHitboxes: true,
  botLink: 'https://t.me/JoyStickerBot',
  // CDN: 'https://cdn.stickerdom.store',
  CDN: 'https://stickerbot.fra1.cdn.digitaloceanspaces.com',
  tonConnectManifestUrl:
    'https://cdn.joincommunity.xyz/glance-stage-tonconnect-manifest.json',
  tonConnectWalletsListSource:
    'https://raw.githubusercontent.com/ton-connect/wallets-list/main/wallets-v2.json',
  accessToken: import.meta.env.VITE_ACCESS_TOKEN,
  adsgramBlockIds: {
    default: '23836',
  },
}

const prodConfig: Config = {
  isProd: true,
  apiHost: import.meta.env.VITE_API_URL,
  showDebugger: false,
  showHitboxes: false,
  botLink: 'https://t.me/JoyStickerBot',
  CDN: 'https://stickerbot.fra1.cdn.digitaloceanspaces.com',
  tonConnectManifestUrl:
    'https://cdn.joincommunity.xyz/glance-tonconnect-manifest.json',
  tonConnectWalletsListSource:
    'https://raw.githubusercontent.com/ton-connect/wallets-list/main/wallets-v2.json',
  adsgramBlockIds: {
    default: '25234',
  },
}

let config

switch (import.meta.env.MODE) {
  case 'localdev':
    config = { ...localdevConfig }
    break
  case 'production':
    config = { ...prodConfig }
    break
  default:
    config = { ...devConfig }
}

export default config as Config
